import archive from './archive';

class Project {
    name = 'project';
    constructor() {
        this.archive = archive;
    }
}
export default new Project();
